const key = "phc_aWveMd1bPhuEYtFnCS1G2IHgln3iGQqjfIdkfnuolxI";
const host = "https://us.i.posthog.com";
const allowLocal =
  (import.meta.env.VITE_POSTHOG_ENABLE_LOCAL as string | undefined) === "true";
const isLocal =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

export const analyticsEnabled = Boolean(key) && (allowLocal || !isLocal);
let client: typeof import("posthog-js").default | null = null;
const queuedEvents: Array<{
  event: string;
  properties?: Record<string, string | number | boolean | null>;
}> = [];

export async function initAnalytics() {
  if (!analyticsEnabled || !key) return;

  try {
    const { default: posthog } = await import("posthog-js");
    client = posthog;
    client.init(key, {
      api_host: host,
      defaults: "2026-05-30",
      capture_pageview: true,
      capture_pageleave: true,
      capture_performance: true,
      capture_exceptions: true,
      person_profiles: "identified_only",
      autocapture: true,
      loaded: (posthogClient) => {
        posthogClient.register({
          site: "investor_updates",
          reporting_period: "march_to_august_2026",
          latest_update: "august_2026"
        });

        queuedEvents.splice(0).forEach(({ event, properties }) => {
          posthogClient.capture(event, properties);
        });
      }
    });
  } catch (error) {
    client = null;
    if (import.meta.env.DEV) {
      console.warn("PostHog failed to initialize", error);
    }
  }
}

export function track(
  event: string,
  properties?: Record<string, string | number | boolean | null>
) {
  if (!analyticsEnabled) return;
  if (!client) {
    queuedEvents.push({ event, properties });
    return;
  }
  client.capture(event, properties);
}
